export default __webpack_public_path__ + "static/media/block-services-5.6c21edfa.webp";